import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import DefaultButton from '../Button';
import CheckIcon from '../Icons/Check';

export default function LanguageItem({ name, label, isDefault, onClick, ...props }) {
  const { i18n } = useTranslation();
  const isDefaultLanguage = isDefault;
  const isCurrentLanguage = name === i18n.language;

  return (
    <Button onClick={onClick} {...props}>
      <Content>
        {label} {isDefaultLanguage && <DefaultText>Default</DefaultText>}
      </Content>
      {isCurrentLanguage && <StyledCheckIcon fill="#95C11F" />}
    </Button>
  );
}

LanguageItem.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isDefault: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

const Button = styled(DefaultButton)`
  justify-content: space-between;
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  & > div {
    margin-right: 4px !important;
  }
`;

const StyledCheckIcon = styled(CheckIcon)`
  width: 14px;
  height: 14px;
  margin-left: 4px;
`;

const DefaultText = styled.span`
  margin-left: 5px;
  color: #9a9a9a;
`;
